import { HashRouter, Switch, Route } from 'react-router-dom';

import BroadcastMessagesTable from './components/BroadcastMessagesTable/index.jsx';
import { NewBroadcastContainer } from './containers/NewBroadcastContainer.jsx';

import { STEPS } from './utils/steps';
import { SingleBroadcast } from './components/SingleBroadcast.jsx';

const Step = props => {
  const CurrentStep = STEPS[props.id].component;
  return <CurrentStep />;
};

export const BroadcastRouting = () => {
  return (
    <HashRouter hashType="noslash">
      <Switch>
        <Route exact path="/">
          <BroadcastMessagesTable />
        </Route>

        <Route
          exact
          path="/:broadcastId"
          render={({ match: { params } }) => (
            <>
              <SingleBroadcast id={params.broadcastId} />
            </>
          )}
        />

        <Route
          path="/edit/:stepId/:broadcastId?"
          render={({ match: { params } }) => (
            <NewBroadcastContainer currentStep={STEPS[params.stepId].id}>
              <Step id={params.stepId} />
            </NewBroadcastContainer>
          )}
        />
      </Switch>
    </HashRouter>
  );
};
